/**
 * Grid-card data-* attributes for Algolia hit templates (matches grid-card.php / strl_get_data_attributes).
 *
 * @param {Record<string, unknown>} hit Algolia record.
 * @param {{ page_title?: string, template_slug?: string }} [vars] Page context from wp_localize_script.
 * @returns {Record<string, string>} Spreadable data-* attributes (empty values omitted).
 */
export function strl_algoliaCardTrackingSpread(hit, vars = {}) {
	/** @type {Record<string, string>} */
	const data = {};

	const title = strl_algoliaCardTitle(hit);
	if (title) {
		data['data-title'] = title;
	}

	const mainSiteId = hit.main_site_id ?? hit.post_id;
	if (mainSiteId !== '' && mainSiteId !== null && mainSiteId !== undefined) {
		data['data-main-site-id'] = String(mainSiteId);
	}

	if (hit.account_title) {
		data['data-account-title'] = String(hit.account_title);
	}

	if (hit.account_id) {
		data['data-account-id'] = String(hit.account_id);
	}

	if (vars.page_title) {
		data['data-page-title'] = String(vars.page_title);
	}

	if (vars.template_slug) {
		data['data-template-slug'] = String(vars.template_slug);
	}

	return data;
}

/**
 * @param {Record<string, unknown>} hit
 * @returns {string}
 */
function strl_algoliaCardTitle(hit) {
	if (typeof hit.post_title === 'string' && hit.post_title) {
		return strl_decodeHtmlEntities(hit.post_title);
	}
	if (typeof hit.title === 'string' && hit.title) {
		return strl_decodeHtmlEntities(hit.title);
	}
	return '';
}

/**
 * @param {string} text
 * @returns {string}
 */
function strl_decodeHtmlEntities(text) {
	if (typeof text !== 'string' || text === '') {
		return text;
	}
	const el = document.createElement('textarea');
	el.innerHTML = text;
	return el.value;
}
